<template>
  <div class="agenda-filter-top">
    <span>{{ total }} sessions</span>
    <span>
      <c-button
        theme="default"
        icon="fa-filter-slash"
        size="sm"
        uppercase
        fill
        @click="$emit('reset')"
      >Reset</c-button>
    </span>
  </div>
</template>

<script>
export default {
  props: ['total']
}
</script>

<style scoped lang="scss">
.agenda-filter-top {
  display: grid;
  grid-template-columns: auto auto;
  justify-content: space-between;
  align-items: center;

  span {
    font-size: 21px;
  }
}
</style>
